import React from "react";

function IllustrationAveragePricePerSqft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 108 96">
      <path
        d="M106.271 92.571H3.929V1.714C3.929.686 3.243 0 2.214 0 1.186 0 .5.686.5 1.714v92.572c0 .514.171.857.514 1.2.343.343.686.514 1.2.514h104.057c1.029 0 1.715-.686 1.715-1.714 0-1.029-.857-1.715-1.715-1.715z"
        className="fill-secondary"
      />
      <path
        d="M44.557 44.057a7.714 7.714 0 100-15.429 7.714 7.714 0 000 15.429z"
        className="fill-primary"
      />
      <path
        d="M71.471 51.943a7.714 7.714 0 100-15.429 7.714 7.714 0 000 15.429zM90.843 32.571a7.714 7.714 0 100-15.428 7.714 7.714 0 000 15.428zM21.414 63.429a7.714 7.714 0 100-15.429 7.714 7.714 0 000 15.429z"
        className="fill-secondary"
      />
    </svg>
  );
}

export default IllustrationAveragePricePerSqft;
